// Fold the server-owned EffectLedger (cost modifiers / threshold grants / mana
// auras) into the client's local `host.effectLedger` under auth (Phase A, A2).
//
// The ledger is server STATE (Witch's Curse MODIFY_CAST_COST, the Blooms'
// grant_threshold, cost-reduction auras). The renders that read it. Cost-modifier
// glow (renderBody), the threshold pool the local seat computes + asserts
// (recalculateSiteAffinities), and the buff panel (HudBuffPanel). Must see server
// truth, not the client's optimistic local ledger. Overwrite-on-fold like
// applyCardStateFromMirror: the authoritative entries replace the local set each
// diff, then the same affinity recompute the legacy ledger-mutation path runs
// refreshes the threshold pool + glow. Idempotent. Skips the recompute when the
// projected ledger is unchanged.

function sameEntries(a, b) {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i += 1) {
    if (a[i]?.id !== b[i]?.id || (a[i]?.usesThisTurn || 0) !== (b[i]?.usesThisTurn || 0)) return false;
  }
  return true;
}

export function applyEffectLedgerFromMirror(host, mirrorState) {
  if (!host.effectLedger) return;
  const led = mirrorState?.effectLedger;
  if (!led || !Array.isArray(led.entries)) return;
  if (sameEntries(host.effectLedger.entries || [], led.entries)) return;
  // Mutate the existing instance (controllers hold it by reference) rather than
  // replacing it.
  host.effectLedger.entries = led.entries.map((e) => ({ ...e }));
  // W3: thresholds fold from players[seat] (applyResourcesFromMirror). The
  // local recompute is an auth no-op now, so refresh the renders that read the
  // ledger directly (hand-glow / buff panel) explicitly.
  host.recalculateSiteAffinities?.();
  host.forceUpdate?.();
}
